export var EmailModes;
(function (EmailModes) {
    EmailModes["RESET_PASSWORD"] = "resetPassword";
    EmailModes["RECOVER_EMAIL"] = "recoverEmail";
    EmailModes["VERIFY_EMAIL"] = "verifyEmail";
})(EmailModes || (EmailModes = {}));
